import { Theme } from "./symbols";

export const westfieldTheme: Theme = {
    name: 'westfield',
    properties: {
      '--background': '#4d514d',
      '--on-background': '#0F0F0F',
      '--primary': '#389BFF',
      '--on-primary': '#fff',
      '--secondary': '#B2B4B7',
      '--on-secondary': '#fff',
      '--surface': '#fff',
      '--on-surface': '#0F0F0F',
      '--error': '#EB5945',
      '--on-error': '#fff',
      '--warning': '#F6BB42',
      '--on-warning': '#fff',
      '--color': '#4d514d',
      '--button-color': '#D62700',
      'font-family': 'Roboto, Arial'
    },
    settings: {
      roundedButtons: false
    }
  };
